import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { ChartModule, NoResultsModule } from '@components';
import { KomodoCoreWrappersModule } from '@komodo-design-system/komodo-core-angular-twelve-wrappers/dist/komodo-core-wrappers';
import { KwaAngular18Module } from '@komodo-design-system/komodo-kwa-angular-18';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import { GridComponent, TitleComponent } from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { NgxEchartsModule } from 'ngx-echarts';

import { ExpandedPanelModule } from '../../components/expanded-panel/expanded-panel.module';
import { SharedModule } from '../../shared.module';
import {
  DistributionChartsComponent,
  FilterMenuComponent,
  KpiChartCardComponent,
  KpiExpandedViewComponent,
  PortfolioKpiExpandedPanelComponent,
  PortfolioKpiSidePanelComponent
} from './components';
import { GroupMenuModule } from './components/group-menu/group-menu.module';
import { HeaderMenuModule } from './components/header-menu/header-menu.module';
import { InsightsCardComponent } from './components/insights-card/insights-card.component';
import { KpiTableCardModule } from './components/portfolio-kpi-panel/kpi-table-card/kpi-table-card.module';
import { PortfolioSkeletonComponent } from './components/portfolio-skeleton/portfolio-skeleton.component';
import { StudyPortfolioComponent } from './study-portfolio.component';

echarts.use([CanvasRenderer, BarChart, PieChart, LineChart, GridComponent, TitleComponent]);

@NgModule({
  declarations: [
    StudyPortfolioComponent,
    DistributionChartsComponent,
    PortfolioSkeletonComponent,
    FilterMenuComponent,
    InsightsCardComponent,
    PortfolioKpiSidePanelComponent,
    PortfolioKpiExpandedPanelComponent,
    KpiChartCardComponent,
    KpiExpandedViewComponent
  ],
  exports: [StudyPortfolioComponent],
  imports: [
    CommonModule,
    KwaAngular18Module,
    KomodoCoreWrappersModule,
    NgxEchartsModule.forRoot({ echarts }),
    MatTableModule,
    MatSortModule,
    RouterModule,
    SharedModule,
    ChartModule,
    MatMenuModule,
    MatButtonModule,
    MatCheckboxModule,
    MatCardModule,
    OverlayModule,
    MatFormFieldModule,
    MatDialogModule,
    MatSelectModule,
    MatDividerModule,
    NoResultsModule,
    ExpandedPanelModule,
    HeaderMenuModule,
    GroupMenuModule,
    KpiTableCardModule
  ]
})
export class StudyPortfolioModule {}
